import { useContext } from "react"
import FormContext from "../../context/FormContext"

function CNViewButton({
    row,
}) {

  const {openCNRecord, setOpenCNRecord, setCurrentCNRecord} = useContext(FormContext)

  const cnDisplayHandler = () => {
    setOpenCNRecord(!openCNRecord)
    setCurrentCNRecord(row)
  }
  return (
    <>
    {
      row["indicator"]["returnorder"] === true &&
          <button
            className="table-options-btn"
            onClick={cnDisplayHandler}
          >
          CND
          </button>
    }
    </>
  )
}

export default CNViewButton;